import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { NavbarHeaderComponent } from '../../components/navbar-header/navbar-header.component';
import { NavbarLinksComponent } from '../../components/navbar-links/navbar-links.component';
import { BrowserService } from 'projects/shared/services/browser.service';

@Component({
  selector: 'app-navbar-main',
  templateUrl: './navbar-main.component.html',
  styleUrls: ['./navbar-main.component.scss'],
  standalone: true,
  imports: [CommonModule, NavbarHeaderComponent, NavbarLinksComponent],
})
export class NavbarMainComponent implements OnInit {
  screenWidth: any;

  isNavbarFixed: boolean = false;


  constructor(
    private _browserService: BrowserService
  ) {
    this.getScreenSize()
  }


  ngOnInit(): void {
  }
  @HostListener('window:scroll', ['$event']) onScroll() {
    const windowBr = this._browserService.getWindow();

    if (windowBr) {

      if (window.scrollY > 100) {
        this.isNavbarFixed = true;
      } else {
        this.isNavbarFixed = false;
      }
    }
  }


  @HostListener('window:resize', ['$event'])

  getScreenSize(event?: any) {
    const windowBr = this._browserService.getWindow();

    if (windowBr) {

      this.screenWidth = window.innerWidth;
    }
  }

}
